import { render, staticRenderFns } from "./RelatedItemsModal.vue?vue&type=template&id=fb9a2210"
import script from "./RelatedItemsModal.vue?vue&type=script&lang=js"
export * from "./RelatedItemsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports